module.exports = __webpack_public_path__ + "img/wz-7-3-1.173cf6ee.jpg";